import React from 'react';
import { angular2react } from 'angular2react';
// eslint-disable-next-line import/named
import { lazyInjector } from '@app/lazyInjector';
// @ts-ignore
import FormBuilder from '@app/listing/appointments/feedback/form_builder.component';
import { FeedbackTemplate } from '@bb/domain/dist/types/Feedback';

const FormBuilderComponent: React.ComponentClass<{
  template: FeedbackTemplate[];
  updateTemplate: (tempalte: FeedbackTemplate[]) => void;
  type?: 'listing' | 'global';
  isPreview?: boolean;
  notEditable?: boolean;
}> = angular2react('bbFormBuilder', FormBuilder, lazyInjector.$injector);

export default FormBuilderComponent;
